/// <amd-module name="TFS/Admin/Groups/Pivots/Permissions/DataSource/PermissionsTraceDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { PermissionTrace } from "TFS/Admin/Common/Contracts/OrganizationSettings";

const PermissionsMetadataProviderId = "ms.vss-admin-web.org-admin-groups-permissions-trace-data-provider";

export function tracePermissions(
    pageContext: IVssPageContext,
    subjectDescriptor: string,
    namespaceId: string,
    token: string,
    permissionBit: string
): Promise<PermissionTrace | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService
        .getDataAsync<PermissionTrace>(PermissionsMetadataProviderId, {
            subjectDescriptor: subjectDescriptor,
            namespaceId: namespaceId,
            token: token,
            permissionBit: permissionBit
        })
        .then(result => {
            return result;
        });
}
